module.exports = __webpack_public_path__ + "static/img/serveBanner.40f7681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serveBanner.png
// module id = zE6e
// module chunks = 2